import { useEffect, useState } from 'react';
import { FALLBACK_REDIRECT_TIMEOUT_MS } from '../constants';

const useRouteFallbackRedirect = ({ action, redirectComponent }) => {
  const [fallbackRedirect, setFallbackRedirect] = useState(false);

  useEffect(() => {
    setFallbackRedirect(false);

    if (redirectComponent) return;

    const timer = setTimeout(() => {
      setFallbackRedirect(true);
    }, FALLBACK_REDIRECT_TIMEOUT_MS);

    return () => clearTimeout(timer);
  }, [action, redirectComponent]);

  return fallbackRedirect;
};

export default useRouteFallbackRedirect;
